import {
  SP_NOTIFIER_LOADING,
  SP_NOTIFIER_LOADED,
  SP_NOTIFIER_CREATED,
  SP_NOTIFIER_EDITED,
  SP_NOTIFIER_DELETED,
  SP_NOTIFIER_FAILED,
  LOGOUT,
  AUTH_FAILED,
} from "../types";

import {
  created,
  editedUpdate,
  deleteFromState,
} from "../../helpers/reduxUtils";

const initialState = {
  loading: false,
  notifiers: [],
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SP_NOTIFIER_LOADING:
      return {
        ...state,
        loading: true,
      };
    case SP_NOTIFIER_DELETED:
      return {
        ...state,
        loading: false,
        notifiers: deleteFromState(state.notifiers, action.payload),
      };
    case SP_NOTIFIER_EDITED:
      return {
        ...state,
        loading: false,
        notifiers: editedUpdate(state.notifiers, action.payload),
      };
    case SP_NOTIFIER_CREATED:
      return {
        ...state,
        loading: false,
        notifiers: created(state.notifiers, action.payload),
      };
    case SP_NOTIFIER_LOADED:
      return {
        ...state,
        loading: false,
        notifiers: action.payload,
      };
    case SP_NOTIFIER_FAILED:
      return {
        ...state,
        loading: false,
      };
    case LOGOUT:
    case AUTH_FAILED:
      return initialState;
    default:
      return state;
  }
}
